/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrMynaLinkStatusUnitTypename = "PhrMynaLinkStatusUnit" as const;

/**
 *
 * @export
 * @interface PhrMynaLinkStatusUnit
 */
export interface PhrMynaLinkStatusUnit {
  /**
   *
   * @type {Date}
   * @memberof PhrMynaLinkStatusUnit
   */
  latestImportedTime?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMynaLinkStatusUnit
   */
  status: PhrMynaLinkStatusUnitStatusEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrMynaLinkStatusUnit
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PhrMynaLinkStatusUnitStatusEnum {
  Executing = "executing",
  Failed = "failed",
  Completed = "completed",
  Unexecuted = "unexecuted",
}

export function PhrMynaLinkStatusUnitFromJSON(json: any): PhrMynaLinkStatusUnit {
  return PhrMynaLinkStatusUnitFromJSONTyped(json, false);
}

export function PhrMynaLinkStatusUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrMynaLinkStatusUnit {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrMynaLinkStatusUnitTypename,

    latestImportedTime:
      !exists(json, "latest_imported_time") ||
      (typeof json["latest_imported_time"] === "string" && json["latest_imported_time"].substring(0, 4) === "0001")
        ? undefined
        : json["latest_imported_time"],
    status: json["status"],
  };
}

export function PhrMynaLinkStatusUnitToJSON(object?: PhrMynaLinkStatusUnit | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    latest_imported_time:
      value.latestImportedTime === undefined ? undefined : tzDate(value.latestImportedTime).format(),
    status: value.status,
  };
}
